import { Component, OnDestroy, OnInit,ViewEncapsulation } from '@angular/core';
import { SpinnerService } from '../../service/spinner.service';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Observable } from 'rxjs';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  encapsulation: ViewEncapsulation.None,

  animations: [
    trigger('fadeAnimation', [
      state('hidden', style({ opacity: 0 })), // Hidden state
      state('visible', style({ opacity: 1 })), // Visible state
      transition('hidden => visible', [animate('1s ease-in')]), // Fade in
      transition('visible => hidden', [animate('1s ease-out')]), // Fade out
    ]),
  ],
})
export class SpinnerComponent implements OnInit, OnDestroy {
  images: { image: string }[] = [];
  text : any;
  currentIndex = 0; // To track the currently displayed image
  interval: any; // To store the interval reference
  animationState: 'hidden' | 'visible' = 'visible'; // To track animation state
  loading$: Observable<boolean>;

  constructor(private router: Router,private spinnerService: SpinnerService) { 
  this.loading$ = this.spinnerService.loading$;
  this.router.events.pipe(
    filter(event => event instanceof NavigationStart || event instanceof NavigationEnd)
  ).subscribe(event => {
    if (event instanceof NavigationStart) {
      this.spinnerService.show();
    } else if (event instanceof NavigationEnd) {
       // Hide loader after a delay of 2 seconds (2000 milliseconds)
       setTimeout(() => {
        this.spinnerService.hide();
      }, 4000);

    }
  });
  }

  ngOnInit() {
    // this.spinnerService.getImages().subscribe((result: { image: string }[]) => {
    //   this.images = result;

    //   if (this.images.length > 0) {
    //     this.animationState = 'visible';
    //     this.startImageRotation();
    //   }
    // });

    // this.spinnerService.getText().subscribe((result: any) => {
    //   this.text = result;
    // });
  }

  startImageRotation() {
    this.interval = setInterval(() => {
      const timestampBefore = new Date().toISOString(); // Log timestamp before animation starts

      // Transition to "hidden" state
      this.animationState = 'hidden';

      setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % this.images.length;

        const timestampAfter = new Date().toISOString(); // Log timestamp after image changes

        this.animationState = 'visible';
      }, 1000); // Match this delay with your "hidden => visible" transition time
    }, 5000); // Rotate every 5 seconds
  }

  ngOnDestroy() {
    // Clear the interval when the component is destroyed
    // if (this.interval) {
    //   clearInterval(this.interval);
    // }
    this.spinnerService.hide();

  }
}
